import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'


import { showAttendance } from '../../../../MyApi/hr/attendances'

import PageHeader from '../../../../Components/UI/PageHeader'
import LoadingSpinner from '../../../../Components/UI/spinner'
import AttendanceDetalis from '../../../../Components/hr/attendance/attendanceShow/levelsDetalis'




const AttendanceShow = () => {
    const {id} =useParams()
    const {data , isLoading}= useQuery(["showAttendance",id], ()=>showAttendance(id))
     const Attendance = data?.data

    if(isLoading){ 
        return <LoadingSpinner/>
    }
    if(!data){
        return<div>no data available</div>
    }
  return (
    <div>
        <PageHeader title="Attendances Detalis" showBack={true} />
        <AttendanceDetalis Attendance={Attendance}/>
    </div>
  )
}

export default AttendanceShow